exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".account-info__container__3Olzn>div{border-bottom:1px solid #a0a09f}.account-info__container__3Olzn>div:last-child{border:none}.account-info__user-email__2a1VZ{padding:25px 20px 10px;color:#000;font-size:14px}.account-info__logout-wrapper__1LnAr{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;padding:20px;line-height:14px}.account-info__logout__3yvUV{font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration;color:#000;text-decoration:underline;font-size:14px}.account-info__logout__3yvUV:active,.account-info__logout__3yvUV:focus,.account-info__logout__3yvUV:hover{opacity:.7}", ""]);

// exports
exports.locals = {
	"container": "account-info__container__3Olzn",
	"user-email": "account-info__user-email__2a1VZ",
	"userEmail": "account-info__user-email__2a1VZ",
	"logout-wrapper": "account-info__logout-wrapper__1LnAr",
	"logoutWrapper": "account-info__logout-wrapper__1LnAr",
	"logout": "account-info__logout__3yvUV"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/account/account-button/account-info/account-info.styl
// module id = 1857
// module chunks = 1 3